import { Pipe, PipeTransform } from '@angular/core';
import { SignedOnUser } from '@data-terminal/shared-models/machine';
import { Role } from '@data-terminal/shared-models/role';

@Pipe({
    standalone: true,
    name: 'filterAvailableCaptains',
})
export class FilterAvailableCaptainsPipe implements PipeTransform {
    transform(signedOnUsers: SignedOnUser[]): SignedOnUser[] {
        return signedOnUsers.filter((u) => !!u.zaikioId && u.role === Role.ASSISTANT);
    }
}
